import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'ks-confirm-dialog',
  standalone: false,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @Input() open = false;
  @Input() eyebrow = 'Please confirm';
  @Input() title = 'Are you sure?';
  @Input() message = '';
  @Input() confirmLabel = 'Confirm';
  @Input() cancelLabel = 'Cancel';
  @Input() tone: 'primary' | 'danger' = 'primary';
  @Input() busy = false;
  /** Shown on the confirm button while `busy`. Override when "Updating…" is the wrong verb. */
  @Input() busyLabel = 'Updating…';

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open && !this.busy) this.cancelled.emit();
  }

  cancel(): void {
    if (!this.busy) this.cancelled.emit();
  }
}
